
import React from "react";
import { attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { defaultDropList } from "../Data/WBComponentDefaults";

import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { ResizeableType, WBComponent } from "./WBComponent";
import LayoutNode, { getNodeComponentAttributeValue, getNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";

import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import MissingSourceDisplay from "vagaro-website-rendering/src/components/MissingSourceDisplay";
import WebDesigner from "../WebDesigner";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";

export default class ImageGrid extends WBComponent{

    constructor(){
        super();
        this.typename =  wBComponentTypeNames.imageGrid;
        this.dropList = defaultDropList
        this.displayName = "Image Grid";
        this.resizeType = ResizeableType.All;
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor"><path d="M48 80V240h96V80H48zM0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48V240c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM304 272V432h96V272H304zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V272zM144 368H48v64h96V368zM48 320h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48zM304 80v64h96V80H304zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80z"/></svg>
        this.editList = [
            attributeTypes.height,attributeTypes.width,
            attributeTypes.gap,
            "imageGridList", "imageGridColumns","innerHeight","imageRadius"
        ];
        this.primaryEditAttributes = ["imageGridList", "imageGridColumns","imageRadius","innerHeight",attributeTypes.gap];
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        
        return [

            new AttributeDefinition("imageGridList","Images","",AttributeInputType.ImageField,[],{min:0,max:24,step:1,unit:""}),
            new AttributeDefinition("imageGridColumns","Number Of Columns","",AttributeInputType.ButtonField,
            [
                {label:"1",value:"1"},
                {label:"2",value:"2"},
                {label:"3",value:"3"},
                {label:"4",value:"4"},
                {label:"5",value:"5"},

            ],{min:0,max:24,step:1,unit:""}),
            new AttributeDefinition("innerHeight","Grid Height","",AttributeInputType.MeasurementField,
            [
                {label:"Auto",value:""},
                {label:"S",value:"750px"},
                {label:"M",value:"1500px"},
                {label:"L",value:"2000px"},
              

            ],{min:200,max:2000,step:1,unit:"px"}),
            new AttributeDefinition("imageRadius","Image Border Radius","",AttributeInputType.MeasurementField,
            [
                {label:"Auto",value:""},
                {label:"S",value:"4px"},
                {label:"M",value:"12px"},
                {label:"L",value:"32px"},
               

            ],{min:0,max:200,step:1,unit:"px"}),
     
        ]
    }

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        thisLayout.screenSizeStyleAttributes[ScreenSize.Desktop] = {gap:"2px"};
    }

    RenderLayout({component,children,screenSize,userContext: siteData,isEditor}:WBRenderProps): JSX.Element {

     
       
 

  
        let imageList = getNodeComponentAttributeValue(component,"imageGridList","");
        let numOfCol = parseInt(getNodeComponentAttributeValue(component,"imageGridColumns","3"));
        const gridHeight = getNodeComponentAttributeValue(component,"innerHeight","1000px");
        let imageListArray =  imageList.length>0?imageList.split(","):[];
        const imageRadius = getNodeComponentAttributeValue(component,"imageRadius","0px");
      
        const atts = GetNodeDomAttributes(" w-full h-full scrollable",component,screenSize,isEditor);
        if(imageListArray.length<=0){

            return (

                <div {...atts}>
                     <MissingSourceDisplay/>
                </div>
            )

        }

        const gap = getNodeStyleAttributeValue(component,screenSize,attributeTypes.gap,"0px");
        const gapWidth = parseFloat(gap);
        const percentStyle = {width:"calc("+ (100/numOfCol)+"% - "+(gapWidth/2)+"px)",height:"auto",borderRadius:imageRadius};

   


        return <div {...atts}>
               <div className="flex-column flex-wrap w-full scrollable" style={{height:gridHeight,gap:gap}}>
            {
             
                imageListArray.map((item:string,index:number)=>{

                    return <img src={item} style={percentStyle} alt={"grid-image-"+index} key={index}/>

                })
            }
                </div>
        </div>
    }

}



